import { FC } from 'react';
import { HeaderGroup, flexRender } from '@tanstack/react-table';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';
interface TableHeaderProps {
  headerGroups: HeaderGroup<any>[];
}

export const TableHeader: FC<TableHeaderProps> = ({ headerGroups }) => {
  return (
    <thead>
      {headerGroups.map(headerGroup => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header, i) => (
            <th
              key={header.id}
              colSpan={header.colSpan}
              onClick={header.column.getToggleSortingHandler()}
              className={`px-6 pb-2 pt-4 text-left text-xs font-medium text-secondary-std tracking-wider ${
                i > 2 && header.column.id !== 'expander' ? 'hidden sm:table-cell' : ''
              } ${header.column.getCanSort() ? 'cursor-pointer select-none' : ''}`}
            >
              <span className="flex gap-2 items-center">
                {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}

                {header.column.getIsSorted() === 'desc' ? (
                  <TiArrowSortedDown className="w-4 h-4" />
                ) : header.column.getIsSorted() === 'asc' ? (
                  <TiArrowSortedUp className="w-4 h-4" />
                ) : null}
              </span>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
